import { useLazyQuery, useMutation } from "@apollo/client";
import { useEffect, useRef, useState } from "react";
import { RiErrorWarningFill } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { useRecoilState } from "recoil";

import pathState from "../../../../atoms/pathstate";
import { ClearSpecificForm } from "../../../../Store/FormDataReducer/FormFieldFunctions";
import {
  CREATE_VEHICLE_MANAGEMENT,
  DELETE_VEHICLE,
  EDIT_VEHICLE_MANAGEMENT,
  Get_Vehicle_By_Id,
} from "../../../../Utils/AllPagesQuriesAndMutations";
import { checkFormErrors } from "../../../custom_hooks/useCheckFormError";
import useConcatenatedString from "../../../custom_hooks/useConcatenatedString";
import useFetchFormFields from "../../../custom_hooks/useFetchFormFields";
import Button from "../../Button/Button";
import { FormInputSectionComponent } from "../../FormInputSectionComponent/FormInputSectionComponent";
import { updateValueForm } from "../../FormInputSectionComponent/formUtils";
import { MultiSelectionComponent } from "../../MultiSelectionComponent/MultiSelectionComponent";
import { useModalContext } from "../../Reactportal/ModalContext";
import PortalFooter from "../../Reactportal/PortalFooter";
import Reactportal from "../../Reactportal/Reactportal";
import { ErrorToast, SuccessToast, WarningToast } from "../../ToastComponent/RectHotToast";
import {
  GET_VEHICLE_CATEGORY,
  GET_VEHICLE_TYPE,
} from "../AddVendorAccount/UserPreferenceAndVehicleCategory/SelectedLanes";
import "./AddVehicleManagent.scss";
import useIsDisabled from "../../../custom_hooks/useIsDisabled";

const AddVehicleManagent = ({
  show,
  TypeOfPortal,
  submitType,
  ParentPortalCloseFunction,
  ReferenceFieldName,
  ReferFormKey,
}) => {
  const { pushModal, popModal } = useModalContext();
  const [isFirstLoad, setFirstLoad] = useState(false);
  const modifiedTypeOfPortal = useConcatenatedString(TypeOfPortal, "Vehicle Managent");
  const Form_Key = "Vehicle_Management";
  const formRef = useRef({});
  const [FormData, setFormdata] = useState({});
  const [vehicleCategory, setCategory] = useState("");
  const [vehicleType, setVehicleType] = useState("");
  const [toggle, settoggle] = useState(show ? show : false);
  const [selectedRows, setSelectedRows] = useState([]);
  const fielddataRedux = useSelector((store) => store.UniqueTableReducer);
  const fielddata = fielddataRedux?.Vehicle_Management?.Selected_Row;
  const FormDataFromRedux = useSelector((store) => store?.FormDataReducer);
  const [{ CurrentTitle }] = useRecoilState(pathState);
  const [allFieldsData, setAllFieldsData] = useState({});
  const dispatch = useDispatch();
  const [formErrors, setFormErrors] = useState({});
  const [showModal, setShowModal] = useState(false);

   const [initialData,setInitialData]=useState({})
  const {isDisabled}=useIsDisabled({TypeOfPortal,initial:initialData, current:FormData});

  //Q & M
  const {
    loading: getFormFieldsLoading,
    data: inputFields,
    getFormSectionAndFields,
  } = useFetchFormFields({ Form_Key });

  const [CreateVechicle, { loading: createVehicleLoading, error: error_v }] = useMutation(CREATE_VEHICLE_MANAGEMENT, {
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  const [GetDataByID, { loading: GetDataByIDLoader }] = useLazyQuery(Get_Vehicle_By_Id, {
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
    fetchPolicy: "network-only",
  });

  const [edit_vehicle_Management, { loading: EditBranchMaster }] = useMutation(EDIT_VEHICLE_MANAGEMENT, {
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  const [deleteVehicle, { loading: DeleteLoading }] = useMutation(DELETE_VEHICLE, {
    context: {
      headers: { "X-GraphQL-Server": "secondary" },
    },
  });

  const VehicleLoadingState = createVehicleLoading || EditBranchMaster || DeleteLoading || GetDataByIDLoader;

  const HanldeChangeonForm = (values) => {
    setFormdata(prev=>{
      const next = {...prev,...values};
      if(!isFirstLoad){
        setInitialData(next)
      }
      return next
    })
  };


  const handleErrorsChange = (newErrors) => {
    setFormErrors((currentErrors) => ({
      ...currentErrors,
      ...newErrors,
    }));
  };

  const Validate_handleSubmit = (submit) => {
    const Error = checkFormErrors(formErrors);

    if (!Error) {
      submit();
    }
  };

  useEffect(() => {
    if (TypeOfPortal !== "Add") {
      getFormSectionAndFields().then(() => {
        GetDataByID({
          variables: {
            id: fielddata?._id,
          },
        }).then(({ data }) => {
          let vehicleManagement = { ...data?.VehicleManagement };

          dispatch({
            type: "SearchMasterData",
            payload: {
              Account_ID: vehicleManagement?.Account_ID,
            },
          });
          vehicleManagement.Account_ID = vehicleManagement?.Account_ID?.Account_Name;
          setCategory(vehicleManagement?.Vehicle_Category?._id);
          setVehicleType(vehicleManagement?.Vehicle_Category?.Vehicle_Type);
          setAllFieldsData(vehicleManagement);
          updateValueForm(formRef, vehicleManagement);
        });
      });
    } else {
      if (ReferenceFieldName?.length > 0) {
        let abc = ReferenceFieldName[0]?.FieldName.Reference_field;
        console.log(abc, ReferFormKey, FormDataFromRedux.MasterData);
        dispatch({
          type: "StoreMasterData",
          payload: {
            formkey: Form_Key,
            data: {
              Account_ID: FormDataFromRedux.MasterData[ReferFormKey]?.[abc],
            },
          },
        });
        setAllFieldsData({ Account_ID: FormDataFromRedux?.MasterData[ReferFormKey]?.[abc]?.Search_Value });
        updateValueForm(formRef, { Account_ID: FormDataFromRedux?.MasterData[ReferFormKey]?.[abc]?.Search_Value });
      } else {
        setAllFieldsData({});
      }
    }
  }, [fielddata]);

  useEffect(() => {
    setSelectedRows(fielddataRedux?.Vehicle_Management?.Selected_Rows);
  }, [fielddataRedux]);

  useEffect(() => {
    pushModal(Form_Key);
    return () => {
      popModal(Form_Key);
    };
  }, []);

  const handleAdd_vehicle_number = () => {
    setShowModal(true);
  };

  const submit = async (close) => {
    let data = FormData;
    if (vehicleCategory) {
      data.Vehicle_Category = vehicleCategory;
    }
    if (vehicleType) {
      data.Vehicle_Type = vehicleType;
    }
    data.Account_ID = FormDataFromRedux?.MasterData[Form_Key]?.Account_ID?._id;

    if (!vehicleType) {
      WarningToast("Please Select Vehicle Category");
      return;
    }
    if (data?.Payload_Capacity) {
      data.Payload_Capacity = String(data.Payload_Capacity);
    }
    if (TypeOfPortal === "Edit" || modifiedTypeOfPortal === "Edit Vehicle Managent") {
      await edit_vehicle_Management({
        variables: { id: allFieldsData._id, Account_ID: data.Account_ID, userInput: data },
      })
        .then((res) => {
          if (CurrentTitle === Form_Key) {
            dispatch({ type: "Refetch", payload: true });
          }
          SuccessToast("Vehicle Master Edited Successfully");
          Closeformfunction();
        })
        .catch((err) => {
          ErrorToast(err.message);
        });
    } else if (TypeOfPortal === "Delete" || modifiedTypeOfPortal === "Delete Vehicle Managent") {
      const ArrayOfID = selectedRows.map((obj) => obj._id);
      await deleteVehicle({
        variables: { idsToDelete: ArrayOfID },
      })
        .then((res) => {
          if (CurrentTitle === Form_Key) {
            dispatch({ type: "Refetch", payload: true });
          }
          SuccessToast("Vehicle Master Deleted ");
          settoggle(false);
        })
        .catch((err) => {
          ErrorToast(err.message);
        });
    } else {
      await CreateVechicle({
        variables: {
          createInput: data,
          Account_ID: FormDataFromRedux?.MasterData[Form_Key]?.Account_ID._id,
        },
      })
        .then((res) => {
          console.log(res);
          let Name = ReferenceFieldName[0].FieldName.name;
          if (CurrentTitle === Form_Key) {
            dispatch({ type: "Refetch", payload: true });
          }
          dispatch({
            type: "StoreMasterData",
            payload: {
              formkey: ReferFormKey,
              data: {
                [Name]: res?.data?.createVehicleManagement,
              },
            },
          });
          SuccessToast("Vehicle Created Successfully");
          if (close === "Close") {
            Closeformfunction();
          }
          setAllFieldsData({});
          setCategory("");
          setVehicleType("");
          ClearSpecificForm(dispatch, Form_Key);
        })
        .catch((err) => {
          settoggle(toggle);
          ErrorToast(err?.message);
        });
    }
    if (error_v) {
      ErrorToast(error_v?.message);
    }
  };

  const Closeformfunction = () => {
    ParentPortalCloseFunction();

    settoggle(false);
    setAllFieldsData({});
    setCategory("");
    setVehicleType("");
    ClearSpecificForm(dispatch, Form_Key);
  };

  const SaveandcloseForadd = () => {
    submit("Close");
  };

  const storeSelectedData = (selectedCat, type, ckeck) => {
    if (ckeck) {
      setCategory(type?._id);
      setVehicleType(selectedCat?._id);
    } else {
      setCategory("");
      setVehicleType("");
    }
  };

  if (TypeOfPortal === "Delete" || modifiedTypeOfPortal === "Delete Vehicle Managent") {
    return (
      <Reactportal
        open={toggle}
        onClose={() => settoggle(false)}
        TypeOfPortal={"Confirm"}
        //id={allFieldsData && allFieldsData?.id ? allFieldsData.id : id}
      >
        <div className="warning">
          <RiErrorWarningFill className="warningIcon" />
          <p className="warningMsg">Are You Sure You Want to Delete this Record?</p>
        </div>

        <PortalFooter
          renderContent={() => <></>}
          disabled={false}
          submitform={submit}
          submitType={"Confirm Delete"}
          handleformclose={() => {
            settoggle(!toggle);
          }}
          loadingState={VehicleLoadingState}
        />
      </Reactportal>
    );
  }

  const footerContent = (
    <PortalFooter
      renderContent={() => <></>}
      disabled={isDisabled}
      submitform={() => Validate_handleSubmit(submit)}
      submitType={submitType}
      Form_key={Form_Key}
      TypeOfPortal={TypeOfPortal}
      SaveAndClose={() => {
        TypeOfPortal === "Add" ? Validate_handleSubmit(SaveandcloseForadd) : Validate_handleSubmit(submit);
      }}
      handleformclose={() => {
        Closeformfunction();
        settoggle(!toggle);
      }}
      loadingState={VehicleLoadingState}
    />
  );

  return (
    <>
      <div>
        <Reactportal
          FoooterContent={footerContent}
          open={toggle}
          onClose={Closeformfunction}
          TypeOfPortal={modifiedTypeOfPortal}
        >
          <>
            {VehicleLoadingState && <div className="loader-line-div" />}
            {showModal && (
              <MultiSelectionComponent
                firstLevelQuery={GET_VEHICLE_TYPE}
                secondLevelQuery={GET_VEHICLE_CATEGORY}
                storeSelectedData={storeSelectedData}
                show={showModal}
                Closeformfunction={() => {
                  setShowModal(false);
                }}
                submit={() => {
                  setShowModal(false);
                }}
                selectedData={vehicleCategory}
                handleCancle={() => setShowModal(false)}
              />
            )}
            <div className="formContainer">
              {inputFields?.length > 0 ? (
                inputFields.map((e) => (
                  <div key={e.id} className="FormSectionParent">
                    <div className="FormSection" style={{ width: "280px", maxWidth: "400px" }}>
                      <FormInputSectionComponent
                        TypeOfPortal={TypeOfPortal}
                        inputfields={e.fields}
                        Type={e.name}
                        onErrorsChange={handleErrorsChange}
                        onhandleFormikChange={HanldeChangeonForm}
                        formRef={formRef}
                        formkey={Form_Key}
                        setFirstLoad={setFirstLoad}
                      />
                      <div className="vehicle_category">
                        <p>Vehicle Category</p>
                        <Button
                          action={handleAdd_vehicle_number}
                          text={vehicleCategory ? "Selected" : "Select"}
                          name="modalbutton"
                        />
                      </div>
                    </div>
                  </div>
                ))
              ) : !getFormFieldsLoading && (inputFields?.message || inputFields?.length === 0) ? (
                <p>No form fields available.</p>
              ) : null}
            </div>
          </>
        </Reactportal>
      </div>
    </>
  );
};

export default AddVehicleManagent;
